import(/* webpackMode: "eager", webpackExports: ["NotFoundTracker"] */ "/work/apps/frontend/src/app/_not-found-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainFooter"] */ "/work/apps/frontend/src/features/layouts/MainFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/work/apps/frontend/src/features/layouts/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingActions"] */ "/work/apps/frontend/src/shared/ui/FloatingActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/work/node_modules/next/dist/client/app-dir/link.js");
